import ResourceBase from './../shared/resource-base';
import WorkflowStepStateModel from './workflow-step-state-model';
import ModelSchemas from './../shared/model-schema';
import { deserialize, custom, serialize, primitive, list, object } from 'serializr';
import WorkflowStepTransitionModel from './workflow-step-transition-model.js';

export default class WorkflowStepStateResource extends ResourceBase {
    constructor() {
        super(WorkflowStepStateModel);

        ModelSchemas.createGenericModelSchema(
            WorkflowStepTransitionModel,
            Object.assign({
                status: primitive(),
                reasons: list(primitive()),
                createdOn: primitive(),
            })
        );
        this.schema = ModelSchemas.createWorkflowStepStateSchema(WorkflowStepStateModel, {
            createdBy: primitive(),
            createdOn: primitive(),
            updatedBy: primitive(),
            updatedOn: primitive(),
            data: custom(
                jsonValue => jsonValue,
                (jsonValue, callback, context, currentPropertyValue) => {
                    return jsonValue;
                }
            ),
            transitions: list(object(WorkflowStepTransitionModel)),
        });
    }

    getStateForFile(token, file) {
        return this.find(token, { filter: { where: { tcFileId: file.tcFileId } } }).then(workflowStateJSON => {
            const stateModels = [];

            workflowStateJSON.forEach(stepStateJSON => {
                stepStateJSON.transitions = stepStateJSON.transitions || [];
                stateModels.push(deserialize(this.schema, stepStateJSON));
            });

            return stateModels;
        });
    }

    getStepStateById(token, id) {
        return this.getById(token, id).then(stepStateJSON => {
            return deserialize(this.schema, stepStateJSON);
        });
    }

    saveStepState(token, stepStateModel, dirtyFields) {
        if (stepStateModel.isNew) {
            return this.createNewStepState(token, stepStateModel);
        } else {
            return this.updateExistingStepState(token, stepStateModel, dirtyFields);
        }
    }

    createNewStepState(token, stepStateModel) {
        return this.post(token, stepStateModel).then(({ body }) => {
            return this.getStepStateById(token, body.workflowStepStateId);
        });
    }

    updateExistingStepState(token, stepStateModel, dirtyFields) {
        return this.patch(
            token,
            stepStateModel.workflowStepStateId,
            _.pick(serialize(stepStateModel), dirtyFields)
        ).then(({ body }) => {
            return this.getStepStateById(token, body.workflowStepStateId);
        });
    }
}



// WEBPACK FOOTER //
// ./src/workflow/workflow-step-state-resource.js